import {React, useContext} from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../security/AuthContext";
import IDPToolbar from "./IDPToolbar";
import Sidebar from "../../components/sidebar/Sidebar";
import AppRoutes from "../../routes/AppRoutes";
import Login from "../security/Login";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, CircularProgress } from "@mui/material";

const drawerWidth = 20; // Sidebar width

const neoFuturisticTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#00eaff" }, // Neon Cyan
    background: { default: "#0d1b2a", paper: "#1a1a2e" },
    text: { primary: "#e0e0e0", secondary: "#00eaff" },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h6: { color: "#00eaff" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          textTransform: "none",
          boxShadow: "0px 0px 10px rgba(0, 234, 255, 0.5)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "rgba(26, 26, 46, 0.8)",
          backdropFilter: "blur(10px)",
          borderRadius: "15px",
          padding: "20px",
        },
      },
    },
  },
});

const MainLayout = () => {
  const { user, loading, entitlements } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#0d1b2a",
        }}
      >
        <CircularProgress sx={{ color: "#00eaff" }} />
      </Box>
    );
  }

  return (
    <Router>
      {user && entitlements ? (
        <Box sx={{ display: "flex", height: "100vh" }}>
          {/* Sidebar */}
          <Sidebar />

          {/* Main Content Wrapper */}
          <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
            {/* Global Toolbar */}
            <IDPToolbar />

            {/* Content Area */}
            <Box sx={{ flexGrow: 1, padding: 1, overflowY: "auto", ml: `${drawerWidth}px` }}>
              <AppRoutes /> {/* Routes for the app */}
            </Box>
          </Box>
        </Box>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
};

export default MainLayout;
